import {
  Grid,
  Paper,
  Typography,
  Box,
  useTheme,
  Pagination,
  Autocomplete,
  TextField,
  LinearProgress,
  Button,
  Checkbox,
  Switch,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import useStyles from "./styles";

import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { Form, useOutletContext } from "react-router-dom";
import AccordionHubsoft from "../../../../components/sevices/accordionHubsoft";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import AccordionVoalle from "../../../../components/sevices/accordionVoalle";
import dayjs from "dayjs";
import { maskCnpj } from "../../../../utils/masks";
import AccordionIxc from "../../../../components/sevices/accordionIxc";
import {
  AddOutlined,
  Cancel,
  Check,
  CheckCircle,
  Clear,
  Close,
  DisabledByDefault,
  FlashOffTwoTone,
  Search,
} from "@mui/icons-material";
import ModalNewService from "../../../../components/sevices/modalNewService";
import AccordionVero from "../../../../components/sevices/accordionVero";

export default function Servicos() {
  const {
    // ERP do cliente aberto (calculado em 2.0-clientes/index.js)
    erp,
    labelErp,
    setSnackbar,
    selectedCliente: clienteInfo,
    searchTerm,
    setSearchTerm,
    selectedService,
    allService,
    setAllService,
    selectStatus,
    setSelectStatus,
    showCanceled,
    setShowCanceled,
    urlServiceId,
  } = useOutletContext();

  // Dono do serviço (grupo econômico: a empresa membro) — o novo ticket do
  // serviço é aberto no ERP dele, com o código dele no ERP.
  const ticketDoServico = (service) => {
    const dono =
      clienteInfo?.membros?.find(
        (membro) => membro?.id === service?.ownerClienteId,
      ) || clienteInfo;
    return {
      erp,
      erpId: dono?.erpId || undefined,
      clienteErpId: service?.ownerClienteErpId ?? dono?.clienteErpId,
    };
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [totalAccordions, setTotalAccordions] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [openNewService, setOpenNewService] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const itemsPerPage = windowWidth > 2500 ? 16 : 11;
  const [rawServices, setRawServices] = useState([]);
  const { paginatedServices, totalPages } = getPaginatedServices({
    allService,
    selectedService,
    selectStatus,
    showCanceled,
    page,
    itemsPerPage,
  });

  useEffect(() => {
    if (clienteInfo) {
      getAllServicesClient(erp);
    }
  }, [clienteInfo]);

  useEffect(() => {
    setPage(1);
  }, [selectedService, selectStatus]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!rawServices) return;

    let filtered = rawServices;

    if (!showCanceled) {
      filtered = filtered?.filter(
        (service) =>
          !String(service?.status || "")
            .toLowerCase()
            .includes("cancelado"),
      );
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();

      filtered = filtered?.filter((service) => {
        const searchableText = Object?.values(service)
          ?.map((value) =>
            typeof value === "object"
              ? JSON.stringify(value)
              : String(value || ""),
          )
          ?.join(" ")
          ?.toLowerCase();

        return searchableText?.includes(term);
      });
    }

    setAllService(filtered);
    setTotalAccordions(filtered?.length || 0);
  }, [rawServices, showCanceled, searchTerm, setAllService]);
  function getPaginatedServices({
    allService,
    selectedService,
    selectStatus,
    showCanceled,
    page,
    itemsPerPage,
  }) {
    let filteredServices = Array.isArray(allService) ? allService : [];
    const selectedServiceId =
      selectedService?.id_cliente_servico ??
      selectedService?.id ??
      urlServiceId;

    if (
      selectedServiceId !== undefined &&
      selectedServiceId !== null &&
      selectedServiceId !== ""
    ) {
      filteredServices = filteredServices?.filter(
        (service) =>
          String(service?.id_cliente_servico ?? service?.id) ===
          String(selectedServiceId),
      );
    }

    if (selectStatus) {
      filteredServices = filteredServices?.filter(
        (service) => service?.status === selectStatus?.status,
      );
    }

    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedServices = filteredServices?.slice(startIndex, endIndex);
    const totalPages = Math?.ceil(filteredServices?.length / itemsPerPage) || 1;

    return { paginatedServices, totalPages };
  }

  const handleOpenNewService = () => {
    setOpenNewService(true);
  };
  // Buscar todos os serviços do cliente
  async function getAllServicesClient(erp) {
    setSelectStatus(null);
    setPage(1);
    setLoading(true);
    try {
      const response = await api.post("/interno/find/allServiceDetailsClient", {
        cnpj: clienteInfo?.cnpj,
        idClienteErp: clienteInfo?.clienteErpId,
        clienteId: clienteInfo?.id,
      });

      if (erp === "HUBSOFT") {
        const services = response?.data?.map((item) => ({
          nome: item?.nome || "",
          referencia:
            item?.referencia === null || item?.referencia === "null"
              ? ""
              : item?.referencia || "",
          id: item?.id_cliente_servico,
          status: item?.status,
          valor: item?.valor,
          enderecoInstalacao: item?.endereco_instalacao?.completo,
          dataHabilitacao:
            item?.data_habilitacao || item?.data_habilitacao_br || "",
          dataCasdastro: item?.data_cadastro,
          tecnologiaUsada: item?.tecnologia,
          login: item?.login,
          senha: item?.senha,
          equipamentoRoteamento: item?.equipamento_roteamento?.nome || "",
          equipamentoRoteamentoIp: item?.equipamento_roteamento?.ipv4,
          interfaceNome: item?.interface?.nome || "",
          interfaceTipo: item?.interface?.tipo,
          portaAtendimento: item?.porta_atendimento?.equipamento || "Nenhuma",
          dataInicioContrato: item?.data_inicio_contrato,
          dataFimContrato: item?.data_fim_contrato,
          vigenciaMeses: item?.vigencia_meses,
          grupos: item?.grupos,
          formaCobranca: item?.forma_cobranca,
          tipoCobranca: item?.tipo_cobranca,
          dataVencimento: item?.vencimento,
          refLabel: item?.refLabel,
          ownerClienteId: item?.ownerClienteId,
          ownerClienteErpId: item?.ownerClienteErpId,
          ownerNome: item?.ownerNome,
        }));

        // Em grupos econômicos, agrupa visualmente os contratos por cliente dono
        if (clienteInfo?.isGrupoEconomico) {
          services?.sort((a, b) =>
            (a?.ownerNome || "").localeCompare(b?.ownerNome || ""),
          );
        }

        setRawServices(services);
      } else if (erp === "VOALLE") {
        const services = response?.data?.map((item) => ({
          nome: item?.nome || "",
          id: item?.id_cliente_servico,
          status: item?.statusContrato,
          cpfCnpj: item?.cpfCnpj,
          valor: item?.totalContrato,
          dataCadastroContrato: item?.dataCadastroContrato || "",
          dataInicioCasdastro: item?.dataInicioContrato,
          dataFimContrato: item?.dataFimContrato,
          dataProximoReajuste: item?.dataProximoReajuste,
          diaVencimento: item?.diaVencimento,
          vigenciaMeses: item?.durationMonthsContrato,
          filialNome: item?.filialNome || "",
          natureFinancer: item?.natureFinancer,
          tipoContrato: item?.tipoContrato,
          tipoCobranca: item?.tipoCobranca,
          contractadress: item?.contractadress,
          subservicos: item?.subservicos,
          ownerClienteId: item?.ownerClienteId,
          ownerClienteErpId: item?.ownerClienteErpId,
          ownerNome: item?.ownerNome,
        }));

        // Em grupos econômicos, agrupa visualmente os contratos por cliente dono
        if (clienteInfo?.isGrupoEconomico) {
          services?.sort((a, b) =>
            (a?.ownerNome || "").localeCompare(b?.ownerNome || ""),
          );
        }

        setAllService(services);
      } else if (erp === "IXC") {
        const services = response?.data?.map((item) => ({
          id: item?.id_cliente_servico,
          baseData: item?.baseData,
          nome: item?.cliente,
          cnpj: item?.cnpj,
          contato: item?.contatoCliente,
          dataAtivacao: item?.dataAtivacao,
          dataExpiracao: item?.dataExpiracao,
          endereco: item?.endereco,
          filial: item?.filial,
          planoContrato: item?.planoContrato,
          renovacaoAutomatica: item?.renovacaoAutomatica,
          status: item?.status,
          enderecoPadraoCliente: item?.enderecoPadraoCliente,
          statusInternet: item?.statusInternet,
          validade: item?.validade,
          valor: item?.valor,
          vencimento: item?.vencimento,
          logins: item?.logins,
          statusIsento: item?.statusIsento,
          vendedorContrato: item?.vendedorContrato,
          canalVendas: item?.canalVendas,
          referencia: item?.referencia,
          descricao: item?.descricaoAuxiliar,
          refLabel: item?.refLabel,
          ownerClienteId: item?.ownerClienteId,
          ownerClienteErpId: item?.ownerClienteErpId,
          ownerNome: item?.ownerNome,
        }));

        // Em grupos econômicos, agrupa visualmente os contratos por cliente dono
        if (clienteInfo?.isGrupoEconomico) {
          services?.sort((a, b) =>
            (a?.ownerNome || "").localeCompare(b?.ownerNome || ""),
          );
        }

        setRawServices(services);
      } else if (erp === "VERO") {
        const service = response?.data?.map((item) => ({
          id: item?.COD_CNTR,
          nome: item?.PRODUTO_NOME,
          formaPagemento: item?.FORM_PAGTO,
          alteracaoWifi: item?.FLAG_PERMITE_ALTERACAO_WIFI,
          categoria: item?.CATEGORIA_PRODUTO,
          vencimento: item?.DIA_VENC,
          dataAtivacao: item?.DAT_ATIV_CNTR,
          dataCancelamento: item?.DAT_CANCL,
          dataCadastro: item?.DAT_CNTR,
          dataInicioCobranca: item?.DAT_INIC_COBR,
          status: item?.DESCR_STAT_CNTR,
          bairro: item?.ENDER_COB_BAIR_NOM,
          cidade: item?.ENDER_COB_CDE_NOM,
          cep: item?.ENDER_COB_CEP,
          complemento: item?.ENDER_COB_COMPL,
          logradouro: item?.ENDER_COB_LOGR_NOM,
          logradouroTipo: item?.ENDER_COB_LOGR_TIPO,
          numeroEndereco: item?.ENDER_COB_NUM,
          uf: item?.ENDER_COB_UF,
          data: item?.FAT_CONTRATO_ITEM,
          valor: item?.VLR_CNTR,
          ownerClienteId: item?.ownerClienteId,
          ownerClienteErpId: item?.ownerClienteErpId,
          ownerNome: item?.ownerNome,
        }));

        // Em grupos econômicos, agrupa visualmente os contratos por cliente dono
        if (clienteInfo?.isGrupoEconomico) {
          service?.sort((a, b) =>
            (a?.ownerNome || "").localeCompare(b?.ownerNome || ""),
          );
        }

        setAllService(service);
      }
      setTotalAccordions(response?.data?.length);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleChangePagination = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Paper sx={styles.paper}>
      {(erp === "HUBSOFT" || erp === "IXC") && (
        <Box sx={styles.boxButtonsHubsoft}>
          <TextField
            label="Buscar"
            size="small"
            placeholder={
              erp === "HUBSOFT"
                ? "Nome, Referência, Endereço e etc..."
                : "Nome, Descrição, Endereço e etc..."
            }
            value={searchTerm || ""}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(1);
            }}
            sx={styles.textfield}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {searchTerm && (
                    <IconButton
                      onClick={() => {
                        setSearchTerm("");
                        setPage(1);
                      }}
                    >
                      <Clear />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />

          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  sx={styles.switch}
                  checked={showCanceled}
                  onChange={(e) => {
                    setShowCanceled(e.target.checked);
                    setPage(1);
                  }}
                  checkedIcon={
                    <CheckCircle sx={{ fontSize: 22, color: "#fff" }} />
                  }
                  icon={<Cancel sx={{ fontSize: 22, color: "#fff" }} />}
                  focusVisibleClassName=".Mui-focusVisible"
                  disableRipple
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    ml: 1,
                    color: showCanceled ? "text.primary" : "text.secondary",
                    fontSize: "0.85rem",
                    userSelect: "none",
                  }}
                >
                  {showCanceled ? "Ocultar Cancelados" : "Mostrar Cancelados"}
                </Typography>
              }
              sx={{ margin: 0 }}
            />
          </FormGroup>
        </Box>
      )}
      <Grid item xs={12} sx={{ mt: 2 }}>
        {loading && <LinearProgress />}
        {totalAccordions === 0 || paginatedServices?.length === 0 ? (
          <Box sx={styles.containerNoTickets}>
            {!loading && (
              <Box
                sx={styles.paperNoTickets}
                elevation={theme.palette.mode === "dark" ? 0 : 3}
              >
                <Box sx={styles.containerImgNoTickets}>
                  <ConfusedMale
                    mainFill={theme.palette.secondary.dark}
                    primaryCircleFill={theme.palette.secondary.main}
                    highlightTitle={"Oops!"}
                    subtitle={`Parece que não\nencontramos nenhum\n${labelErp.toLocaleLowerCase()}.`}
                  />
                </Box>
              </Box>
            )}
          </Box>
        ) : erp === "HUBSOFT" ? (
          paginatedServices?.map((service) => (
            <AccordionHubsoft
              key={service?.id}
              ticket={ticketDoServico(service)}
              clienteId={service?.ownerClienteId || clienteInfo?.id}
              ownerNome={service?.ownerNome}
              id={service?.id}
              nome={service?.nome}
              status={service?.status}
              referencia={service?.referencia}
              valor={service?.valor}
              enderecoInstalacao={service?.enderecoInstalacao}
              dataHabilitacao={service?.dataHabilitacao}
              dataCasdastro={service?.dataCasdastro}
              tecnologiaUsada={service?.tecnologiaUsada}
              login={service?.login}
              senha={service?.senha}
              equipamentoRoteamento={service?.equipamentoRoteamento}
              equipamentoRoteamentoIp={service?.equipamentoRoteamentoIp}
              interfaceNome={service?.interfaceNome}
              interfaceTipo={service?.interfaceTipo}
              portaAtendimento={service?.portaAtendimento}
              dataInicioContrato={service?.dataInicioContrato}
              dataFimContrato={service?.dataFimContrato}
              vigenciaMeses={service?.vigenciaMeses}
              grupos={service?.grupos}
              setSnackbar={setSnackbar}
              formaCobranca={service?.formaCobranca}
              tipoPagamento={service?.tipoCobranca?.tipo_pagamento}
              tipoCobranca={service?.tipoCobranca?.tipo_cobranca}
              dataVencimento={service?.dataVencimento}
              clienteInfo={clienteInfo}
            />
          ))
        ) : erp === "VOALLE" ? (
          paginatedServices?.map((service) => {
            return (
              <AccordionVoalle
                key={service?.id}
                ownerNome={service?.ownerNome}
                id={service?.id}
                nome={service?.nome}
                status={service?.status}
                setSnackbar={setSnackbar}
                cpfCnpj={maskCnpj(service?.cpfCnpj)}
                dataCadastroContrato={dayjs(
                  service?.dataCadastroContrato,
                ).format("DD/MM/YYYY HH:mm")}
                dataFimContrato={dayjs(service?.dataFimContrato).format(
                  "DD/MM/YYYY HH:mm",
                )}
                dataInicioContrato={dayjs(service?.dataInicioCasdastro).format(
                  "DD/MM/YYYY HH:mm",
                )}
                dataProximoReajuste={dayjs(service?.dataProximoReajuste).format(
                  "DD/MM/YYYY HH:mm",
                )}
                diaVencimento={service?.diaVencimento}
                filialNome={service?.filialNome}
                natureFinancer={service?.natureFinancer}
                tipoCobranca={service?.tipoCobranca}
                tipoContrato={service?.tipoContrato}
                valor={service?.valor}
                vigenciaMeses={service?.vigenciaMeses}
                contractadress={service?.contractadress}
                subservicos={service?.subservicos}
              />
            );
          })
        ) : erp === "IXC" ? (
          paginatedServices?.map((service) => (
            <AccordionIxc
              key={service?.id}
              ticket={ticketDoServico(service)}
              id={service?.id}
              baseData={service?.baseData}
              cliente={service?.nome}
              dataAtivacao={service?.dataAtivacao}
              dataExpiracao={service?.dataExpiracao}
              endereco={service?.endereco}
              planoContrato={service?.planoContrato}
              renovacaoAutomatica={
                service?.renovacaoAutomatica === "S" ? "Ativada" : "Desativada"
              }
              status={service?.status}
              statusInternet={service?.statusInternet}
              validade={service?.validade}
              valor={service?.valor}
              vencimento={service?.vencimento}
              setSnackbar={setSnackbar}
              logins={service?.logins}
              filial={service?.filial}
              vendedorContrato={service?.vendedorContrato}
              enderecoPadraoCliente={service?.enderecoPadraoCliente}
              statusIsento={
                service?.statusIsento === "S" ? "Ativado" : "Desativado"
              }
              canalVendas={service?.canalVendas}
              clienteInfo={clienteInfo}
              descricao={service?.descricao}
              ownerNome={service?.ownerNome}
            />
          ))
        ) : erp === "VERO" ? (
          paginatedServices?.map((service) => (
            <AccordionVero
              key={service?.id}
              ownerNome={service?.ownerNome}
              id={service?.id}
              nome={service?.nome}
              status={service?.status}
              setSnackbar={setSnackbar}
              dataCadastroContrato={
                service?.dataCadastro
                  ? dayjs(service?.dataCadastro).format("DD/MM/YYYY HH:mm")
                  : "-"
              }
              dataFimContrato={
                service?.dataCancelamento
                  ? dayjs(service?.dataCancelamento).format("DD/MM/YYYY HH:mm")
                  : "-"
              }
              dataInicioContrato={
                service?.dataAtivacao
                  ? dayjs(service?.dataAtivacao).format("DD/MM/YYYY HH:mm")
                  : "-"
              }
              formaPagamento={service?.formaPagemento}
              diaVencimento={service?.vencimento}
              categoria={service?.categoria}
              permiteAlterarWifi={service?.alteracaoWifi}
              enderecoCompleto={`${service?.logradouroTipo || ""} ${service?.logradouro || ""}, ${service?.numeroEndereco || ""} ${service?.complemento ? "- " + service?.complemento : ""} - ${service?.bairro || ""} - ${service?.cidade || ""}/${service?.uf || ""} - CEP: ${service?.cep?.replace(/^(\d{5})(\d{3})$/, "$1-$2") || ""}`.trim()}
              itensFaturamento={service?.data}
              data={service?.data}
              valor={service?.valor}
            />
          ))
        ) : null}

        {totalPages > 1 && totalAccordions > 0 && (
          <Box sx={styles.pagination}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePagination}
            />
          </Box>
        )}
      </Grid>
      {/* <ModalNewService
				setOpenNewService={setOpenNewService}
				openNewService={openNewService}
			/> */}
    </Paper>
  );
}
